var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReadOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM7 7.7a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4Zm0-2.45a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM7 7.7a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4ZM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Zm0 9.8A4.53 4.53 0 0 1 2.8 7a4.554 4.554 0 0 1 5.95-2.45A4.564 4.564 0 0 1 11.2 7 4.53 4.53 0 0 1 7 9.8Zm0-4.55a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM7 7.7a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReadOnly);
export default __webpack_public_path__ + "static/media/icon--read-only.067ce0b1b45d2a107591f3300b6f5f75.svg";
export { ForwardRef as ReactComponent };